import * as React from 'react';
import './styles.scss';



export default  class ConfirmBoxButton extends React.Component  {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="control-bar rowFlex alignRight modalFooter">
                
                
                <button
                    className={ `btn buttonGradient${this.props.confirmDisabled ? ' disabled' : ''}` }
                    onClick={ this.props.onConfirmClick }
                    disabled={ this.props.confirmDisabled }
                >
                    { this.props.confirmText || 'Confirm' }
                </button>
                {(!this.props.hideCancel)
                    ?
                    <div style={{ display: 'inline-block' }}>
                        {
                            (this.props.middleText !== '')
                            ?
                            (
                             <div className="element center">{this.props.middleText || "or"}</div>
                            )
                            :
                            null
                        }
                        {
                            (this.props.bothButton)
                            ?
                            (
                                <button className="btn link" onClick={this.props.onCancelClick}>
                                    {this.props.cancelText || 'Cancel'}
                                </button>
                            )
                            :
                            (
                                <a href="javascript:void(0);" className="confirmBoxCancel" onClick={this.props.onCancelClick} >{this.props.cancelText || 'Cancel'}</a>
                            )
                        }

                    </div>
                    :
                    ""
                }
            </div>
        )
    }
}